import { useEffect, useState } from 'react';

/**
 * Hook to manage Curator state and event handling.
 * Listens for 'toggleCurator' custom events dispatched by the header component.
 */
export const useCurator = () => {
  const [isCuratorOpen, setIsCuratorOpen] = useState(false);

  useEffect(() => {
    const handleToggleCurator = () => {
      setIsCuratorOpen((prev) => !prev);
    };

    document.addEventListener('toggleCurator', handleToggleCurator);

    return () => {
      document.removeEventListener('toggleCurator', handleToggleCurator);
    };
  }, []);

  const handleToggle = () => {
    // Toggle curator when user interacts with curator itself (e.g., close button)
    document.dispatchEvent(new CustomEvent('toggleCurator'));
  };

  return {
    isCuratorOpen,
    handleToggle,
  };
};
